import { makeStyles, tokens, shorthands } from "@fluentui/react-components";
import { ellipsis } from "@/common/style/commonStyle";
import { Colors } from "@/common/constants";

export const CC_HEADER_ACTIONS = "cc-header-actions";

export const useTableStyle = makeStyles({
	row: {
		height: "54px",
	},
	noHeaderRow: {
		minHeight: "0px !important",
		height: "0px !important",
		lineHeight: "0px",
	},
	noHeaderHeaderCell: {
		"& > div": {
			minHeight: "0px",
			height: "0px",
		},
	},
	headerText: {
		color: tokens.colorNeutralForeground2,
		fontSize: tokens.fontSizeBase200,
	},
	bodyText: {
		color: tokens.colorNeutralForeground3,
	},
	primaryText: {
		color: tokens.colorNeutralForeground1,
		fontSize: tokens.fontSizeBase300,
		fontWeight: tokens.fontWeightSemibold,
	},
	timer: {
		color: tokens.colorNeutralForeground1,
	},
	supervisorButtonColor: {
		color: tokens.colorBrandBackground,
	},
	supervisorInteractionSkillPopoverTrigger: {
		lineHeight: tokens.lineHeightBase300,
		display: "block",
	},
	table: {
		">tr": {
			borderBottomColor: tokens.colorNeutralBackground5,
			"&:hover, &:hover:active": {
				backgroundColor: tokens.colorNeutralBackground1Hover,
			},
		},
	},
	stickyHeader: {
		position: "sticky",
		top: 0,
		zIndex: 1,
	},
	resizableHeaderCell: {
		...shorthands.borderRight(`1px solid ${tokens.colorNeutralStroke1}`),
	},
	interactiveHeaderCell: {
		"&:hover .cc-header-actions": {
			display: "flex",
		},
		"&:focus-within .cc-header-actions": {
			display: "flex",
		},
	},
	sortableHeaderCell: {
		cursor: "pointer",
	},
	headerCellInner: {
		display: "flex",
		alignItems: "center",
		flexGrow: 1,
		minWidth: 0,
		width: "100%",
	},
	headerLabelGroup: {
		display: "flex",
		alignItems: "center",
		flexGrow: 1,
		flexShrink: 1,
		minWidth: 0,
		columnGap: "4px",
	},
	headerLabel: {
		flexShrink: 1,
		minWidth: 0,
		...ellipsis(),
	},
	headerActions: {
		display: "none",
		// zero height, buttons overflow centered: revealing them on hover must not
		// resize a content-height header row
		height: "0px",
		flexShrink: 0,
		alignItems: "center",
		columnGap: "2px",
	},
	affordanceButton: {
		minWidth: "24px",
		maxWidth: "24px",
		height: "24px",
		padding: 0,
	},
	sortHintIcon: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: tokens.colorNeutralForeground2,
	},
	ellipsis: {
		...ellipsis(),
	},
	tooltip: {
		maxWidth: "none",
		fontWeight: "none",
		zIndex: "5",
	},
	columnCellText: {
		fontSize: tokens.fontSizeBase300,
		maxWidth: "100%",
		textAlign: "left",
		color: tokens.colorNeutralForeground1,
	},
	tooltipText: {
		fontSize: tokens.fontSizeBase200,
	},
	tooltipContent: {
		maxWidth: "none",
	},
	tooltipContentContainer: {
		...shorthands.margin("5px", "10px"),
	},
	fontWeightSemibold: {
		fontWeight: tokens.fontWeightSemibold,
	},
	textContainerWithPadding: {
		...shorthands.overflow("hidden"),
		...shorthands.margin("0px", "0px", "0xp", "10px"),
	},
	textContainerWithoutPadding: {
		...shorthands.overflow("hidden"),
		...shorthands.margin("0px", "0px", "0xp", "0px"),
	},
	iconColumn: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	bold: {
		fontWeight: tokens.fontWeightBold,
	},
	cursorPointer: {
		cursor: "pointer",
	},
	customPaddingButton: {
		paddingLeft: "11px",
		paddingRight: "11px",
		backgroundColor: Colors.ButtonGreenBackground,
		minWidth: "100px",
		"&:hover, &:hover:active": {
			backgroundColor: Colors.ButtonGreenBackground,
		},

		"@container allWaitingInteractions (width < 556px)": {
			...shorthands.borderRadius("1.6px"),
			paddingLeft: "2px",
			paddingRight: "2px",
			minWidth: "32px",
			display: "flex",
			justifyContent: "center",

			"& > span": {
				marginRight: "unset",
				marginLeft: "4px",
			},
		},
	},

	buttonLabel: {
		"@container allWaitingInteractions (width < 556px)": {
			display: "none",
		},
	},

	customAvatar: {
		height: "36px",
		width: "36px",
		minWidth: "36px",
		boxSizing: "border-box",
		borderRadius: "50%",
		backgroundColor: tokens.colorNeutralBackground4Hover,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		padding: "1px",
	},

	iconTableColumn: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		marginLeft: "8px"
	},

	waitingInteractionAvatar: {
		color: tokens.colorNeutralForeground3,
		border: `1px solid ${tokens.colorTransparentStroke}`,
	},

	// Spacing only — the arrow itself is the shared DirectionArrow atom.
	directionArrow: {
		marginRight: "2px",
	},
});
